export const Global = {
  domainUrl: '',
  LOG_OFF_API: 'awcp/user/logout',
  GENESYS_LOGOUT: 'awcp/user/genesysLogout',
  LOGIN_API: 'awcp/user/authenticate',
  TBA_GUI_REGISTER_API: 'awcp/tbaguiwf/authenticateRACFID',
  TBA_GUI_GET_DATA_API: 'awcp/tbaguiwf/getTBAGUIWebFrontData',
  GET_APP_CONFIG: 'awcp/common/getApplicationConfigurations',
  IS_DUPLICATE_SESSION: 'awcp/sso/checkActiveSession',
  GET_USER_DETAILS: 'awcp/user/getUserDetails',
  HANDLE_MULTI_SESSION: 'awcp/user/handleMultiSession',
  HANDLE_MULTI_SESSION_SSO: 'awcp/user/handleMultiSessionSSO',
  UPDATE_USER_QUEUE: 'awcp/user/updateUserQueue',
  // GET_IH_BRIEF_DATA: 'awcp/interactionhistory/getInteractions',
  //GET_IH_LIST_DATA: 'awcp/interactionhistory/getInteractionsListDetails',
  GET_IH_BRIEF_DATA: 'awcp/interactionhistory/topIHDocMsgsData',
  GET_IH_LIST_DATA: 'awcp/interactionhistory/ihDocMsgsListDetails',
  GET_REPEAT_ALERT: 'awcp/interactionhistory/interactionDataBycontactIdAndDays',
  UPDATE_CUSTOMER_EC: 'awcp/api/customer/updateCustomerInElasticCache',
  GET_SSO_LINK: 'awcp/api/link/getLinkUrl',
  isSessionActive: 'awcp/user/isSessionActive',
  DELETE_CUSTOMER_EC: 'awcp/api/customer/deleteCustomerById', // CCR3-11850 Penetration Testing Sensitive Data Remediation
  UPDATE_USER_EC: 'awcp/user/updateUser',
  ALERTS_TEMPLATES: 'awcp/alerts/templates',
  CREATE_ALERTS: 'awcp/api/alerts',
  GET_EXPIRED_ALERTS : 'awcp/api/expiredAlerts',
  DELETE_EXPIRED_ALERTS : 'awcp/api/expireAlerts',
  SAVE_EDIT_ALERTS: 'awcp/api/alerts/',
  GET_TOPIC_LIST: 'awcp/wrapup/getTopicsList',
  GET_DOCUMENT_CONTENT: 'awcp/documents/viewDocument',
  GET_MESSAGE_CONTENT: 'awcp/documents/viewMessage',
  GET_AGENT_INTERACTION_DATA: 'awcp/interactionhistory/agentIHData',
  GET_CLIENT_MAPPING: 'awcp/user/getUserClientSystemMapping',
  GET_USER_CLIENT_PROPERTY: "awcp/user/getUserClientProperty",
  LOAD_TEST_USER_LOGIN: 'awcp/sso/loadTestLogin',
  GET_PRE_AUTH_CONFIG: 'awcp/client/getPreAuthClientConfig',
  GET_PRE_AUTH_IDENTIFY_USER: 'awcp/client/preAuthIdentifyUser',
  UPDATE_USER_DB_SELECTER: 'awcp/user/updateUser ',
  PIN_RESET_COMMUNICATION: 'awcp/client/getPinResetCommunication',
  SENT_PIN_RESET: 'awcp/client/pinReset',
  PIN_RESET_TBA_GUI_TEMP_ADD_COMMUNICATION: 'awcp/navigation/menu',
  UPDATE_WRAPUP_COMMENTS : 'awcp/interactionhistory/interactionHistory',
  GET_CLIENT_MAPPING_NEW : 'awcp/user/getUserClientProperties',
  VAL_RELOCK_API:'awcp/account/accountRelock',
  VIEW_UDPDATA_JSON_API:'awcp/participant/getViewJsonData',
  CHECK_MULTIPLE_ACTIVE_CALL:"awcp/api/customer/checkParticipantActiveCall",
  ssoLogin: {
    testApi: 'awcp/sso/',
    getConfigDetails: 'awcp/common/getApplicationConfigurations',
    validateSession: 'awcp/sso/validateSession'
  },
  
 
  customerApi: {
    fetchCustomerData: 'awcp/customerSearch/fetchCustomerData',
    getCustomersession: 'awcp/api/customer/session',
    panelId: 'awcp/api/customer/panelId',
    csPro: 'awcp/api/v1/customer/fetchCsPro',
    customerType: 'awcp/api/v1/customer/getCustomerType',
    sql: 'awcp/api/v1/customer/fetchPostgreSql',
    CustomerData: 'awcp/api/v1/customer/fetchCustomerData',
    hasPro: 'awcp/api/v1/customer/fetchHasBro',
    AD: 'awcp/api/v1/customer/fetchAD/',
    lambda: 'awcp/api/v1/customer/fetchLambda',
    clientResponseList: 'awcp/user/getUserClientEntitlements',
    getClientSystemMapping: 'awcp/client/getClientSystemMapping',
    getRestoreAccountDetails: "awcp/api/customer/getRestoreAccountDetails",
    getTopicListByDomain: 'awcp/api/link/getTopicListByDomain',
    getTbaKcArticleLinks: 'awcp/api/link/getTbaKcArticleLinks',
    getApprovedExceptionLists: 'awcp/approvedException/getApprovedExceptionList',
    getEgainContent: 'awcp/egain/fetchEgainContent',
    autoLaunchAPI: 'awcp/api/link/autoLaunchConfig',
    clientInfoCardDefaultPinService: 'awcp/usersettings/userPinService',
    getAuthenticationModel: 'awcp/authentication/getAuthenticationModel'
  },
  openAccountApi: {
    GetOpenAccountDetails: 'openAccount/Get',
    getPersonData: 'awcp/person/getPersonData',
    customerNavigation: 'awcp/navigation/menu',
    getRoleTypeList: 'awcp/person/listsOfParticipantRoles',
    getCustomerPreferredAddress:'awcp/person/getCustomerPreferredAddress',
    pinReminder:'awcp/hasbro/pinReminder'
  },
  authenticationApis: {
    gethenticationContentList: 'awcp/authentication/getAuthenticationContentList',
    fetchEgainContent: 'awcp/egain/fetchEgainContent',
    validateIndicativeData: 'awcp/validate/indicativeData',
    loadOTCConfig: 'awcp/otc/loadClientCustomerConfig',
    generateOTC : 'awcp/otc/generateOTC',
    validateOTC: 'awcp/otc/validateOTC',
    getAaasEnabledClient:"awcp/client/getAaasEnabledClient",
    getAaaSFtuFields:"awcp/client/getAaaSClientConfig",
    getAaasAuthMethods:"awcp/client/aaasIdentifyUser",
    getPrivacyPolicyStatus:"awcp/policy/fetchPrivacyPolicyStatus",
    updatePrivacyPolicyStatus:"awcp/policy/updatePrivacyPolicyStatus",
     sendPcsNotification:"awcp/policy/sendPcsNotification"
    
  },
  dashboardApi: {
    getCaseManagementDetails: 'awcp/api/link/getLinks',
    ValidValuesApi: 'awcp/common/getValidValuesByValidFieldKey',
    SAVE_PREFERENCE_VALUE: 'awcp/usersettings/updateFeatureSetting/ALIS',
    dashboardLeftNavigation: 'awcp/navigation/menu',
    validValuesAPINew : 'awcp/api/getValidFieldValues'
  },
  customerAccountApi: {
    getCaseManagementDetail: 'awcp/api/link/getLinks'
    
  },
  backendDetailsAPI: {
    getBuildDetail: 'awcp/application/buildDetails',
  },
  batchAlerts :{
    CREATE_BATCH_ALERT : 'awcp/api/batchalerts',
    DELETE_BATCH_ALERT : 'awcp/api/batchalerts',
    ARCHIVED_BATCH_ALERT: 'awcp/api/archivedbatchalerts',
    VIEW_PARTICIPANT_BATCH_ALERT:'awcp/api/viewparticipants'
  },

  onDemandEmail : {
    LOAD_EMAIL_CONFIG : 'awcp/email/loadEmailConfig',
    SEND_EMAIL:'awcp/email/sendEmail'
  },

  GET_IMAGING_NOTELOG : 'awcp/imaging/getImagingNoteLogByDocumentId', // CCR1-11727 View Notelog From Imaging
  SAVE_IMAGING_NOTELOG : 'awcp/imaging/updateImagingNoteLogByDocumentId', // CCR1-11945 Save Notelog From Imaging
  CLEAR_APIS: {
    CLEAR_IDENTITY_VERIFICATION: 'awcp/idv/clientIdentityVerification',
    STARTIDENTITYVERIFICATION: 'awcp/idv/startIdentityVerification',
    POLL_CALLBACK_RESPONSE: 'awcp/idv/pollCallbackResponse',
    INVALIDATE_IDENTITY_VERIFICATION_SESSION: 'awcp/idv/invalidateIdentityVerificationSession',
    REFRESH_IDV_STATUS:'awcp/idv/refreshIDVStatus'
   
  }
};


export const ActionEnum = Object.freeze({
  Save: 'a',
  Edit: 'e',
  Delete: 'd',
  Cancel: 'c',
});
